export const GET_PROCESSES = 'GET_PROCESSES';
export const SET_PROCESSES = 'SET_PROCESSES';
export const FIND_PROCESSES_BY_FILTERS = 'FIND_PROCESSES_BY_FILTERS';

export const getProcesses = (username, application) => {
  return { type: GET_PROCESSES, data: { username, application } }
}

export const setProcesses = (processes) => {
  return { type: SET_PROCESSES, data: processes }
}

export const findProcessesByFilters = (username, application, nProcess, startAt, endAt, PROCESS_STATUS) => {
  return { type: FIND_PROCESSES_BY_FILTERS, data: { username, application, nProcess, startAt, endAt, PROCESS_STATUS } };
}

